import { Button, IconButton } from '@sobrus-com/sobrus-design-system-v2';
import './ReloadPrompt.scss';

import reload from './reload.svg';
import iconReload from './iconReload.svg';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { IoCloseOutline } from 'react-icons/io5';
import { useRegisterSW } from 'virtual:pwa-register/react';

function ReloadPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r: ServiceWorkerRegistration | undefined) {
      console.info('onRegistered,r', r);
    },
    onRegisterError(error: any) {
      console.info('SW registration error', error);
    },
    onOfflineReady() {
      console.info('offfffffline');
    },
  });
  const { t } = useTranslation();

  const [openPopup, setOpenPopup] = useState(false);

  const handleUpdate = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration?.waiting) {
      window.location.reload();
      return;
    }
    navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), {
      once: true,
    });
    await updateServiceWorker(true);
  };

  return (
    <div>
      {needRefresh ? (
        !openPopup ? (
          <div aria-hidden className='image__open_container' onClick={() => setOpenPopup(true)}>
            <img alt='' src={iconReload} />
          </div>
        ) : (
          <div className='ReloadPrompt-container'>
            <div className='ReloadPrompt-toast'>
              <div className='ReloadPrompt-headerContainer'>
                <div className='image__container'>
                  <img alt='' src={reload} />
                </div>
                <IconButton color='secondary' size='sm' onClick={() => setOpenPopup(false)}>
                  <IoCloseOutline color='#E74C3C' size={16} />
                </IconButton>
              </div>
              <div className='ReloadPrompt-message'>
                <span>{t('New update avilable')}.</span>
              </div>
              <div className='ReloadPrompt-submessage'>
                <span>
                  {t(
                    'To avoid losing any changes made please click on "Update" besfore closing de window',
                  )}
                  .
                </span>
              </div>

              <Button block onClick={handleUpdate}>
                {t('Update')}
              </Button>
            </div>
          </div>
        )
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default ReloadPrompt;
